import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Account } from '../../models';
import { LoginModalService } from '../login';
import { Principal } from '../../services';

@Component({
    selector: 'qms-error',
    templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
    public errorMessage: string;
    public error403: boolean;

    constructor(private route: ActivatedRoute,
                private loginModalService: LoginModalService,
                private principal: Principal) {
    }

    ngOnInit() {
        this.route.data.subscribe((routeData) => {
            if (routeData.error403) {
                this.error403 = routeData.error403;
            }
            if (routeData.errorMessage) {
                this.errorMessage = routeData.errorMessage;
            }
        });

        this.principal.identity().then((account: Account) => {
            /* Only show the login dialog, if the user hasn't logged in yet */
            if (!account) {
                this.loginModalService.open();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/error/error.component.ts